import React, { FC, UIEvent, useLayoutEffect, useRef } from 'react'

import useEvent from 'Hooks/useEvent'
import { useChatAuth } from 'Pages/Chat/AuthProvider'
import { Chat } from 'Types'

import useMessages from './hooks/useMessages'
import Message from './Message'
import SignUpForm from './SignUpForm'
import Typing from './Typing'

interface Props {
  chat: Chat
  hideSignupForm(): void
  open: boolean
  openSignupForm: boolean
}

const Messages: FC<Props> = ({ chat, open, openSignupForm, hideSignupForm }) => {
  const { uid } = useChatAuth()
  const [{ messages, hasMore }, getMessages] = useMessages(chat.id, { open })
  const lastMessage = messages.at(-1)
  const messageBox = useRef<HTMLDivElement | null>(null)

  useLayoutEffect(() => {
    const list = messageBox.current
    if (list && lastMessage?.authorId == uid) {
      list.scrollTop = 0
    }
  }, [lastMessage, uid])

  const handleScroll = useEvent((event: UIEvent) => {
    const { scrollTop, scrollHeight, clientHeight } = event.currentTarget
    const tolerance = 10

    // NOTE: column-reverse makes scrollTop negative
    if (Math.abs(scrollTop) + clientHeight >= scrollHeight - tolerance && hasMore) {
      void getMessages()
    }
  })

  return (
    <div
      ref={messageBox}
      className="chatBox__dialog--body--wrap"
      style={{ position: 'relative' }}
      onScroll={handleScroll}
    >
      <ul className="chatBox__dialog--body">
        {messages.map((message) => (
          <Message key={message.id} customerId={chat.customerId} message={message} />
        ))}

        {openSignupForm ? <SignUpForm hideSignupForm={hideSignupForm} /> : null}

        <Typing chatId={chat.id} />
      </ul>
    </div>
  )
}

export default Messages
